import React from "react";
import ReactDOM from "react-dom";
import { Parallax, ParallaxLayer } from "react-spring/renderprops-addons";
import Typography from "@material-ui/core/Typography";

import geslubLogo from "../../assets/images/geslub_simbolo_principal.png";

// Little helpers ...
const url = (name, wrap = false) =>
  `${
    wrap ? "url(" : ""
  }https://awv3node-homepage.surge.sh/build/assets/${name}.svg${
    wrap ? ")" : ""
  }`;
const Pink = ({ children }: any) => (
  <span style={{ color: "#FF6AC1" }}>{children}</span>
);
const Yellow = ({ children }: any) => (
  <span style={{ color: "#EFF59B" }}>{children}</span>
);
const Lightblue = ({ children }: any) => (
  <span style={{ color: "#9AEDFE" }}>{children}</span>
);
const Green = ({ children }: any) => (
  <span style={{ color: "#57EE89" }}>{children}</span>
);
const Blue = ({ children }: any) => (
  <span style={{ color: "#57C7FF" }}>{children}</span>
);
const Gray = ({ children }: any) => (
  <span style={{ color: "#909090" }}>{children}</span>
);

import { Card } from "../../components";

const Home = (): React.ReactElement => {
  return (
    <Parallax
      // @ts-ignore
      ref={(ref) => (React.parallax = ref)}
      // @ts-ignore
      style={{ width: "100%", backgroundColor: "white" }}
      pages={3}>
      <ParallaxLayer
        offset={1}
        speed={1}
        // @ts-ignore
        style={{ backgroundColor: "#805E73" }}
      />
      <ParallaxLayer
        offset={2}
        speed={1}
        // @ts-ignore
        style={{ backgroundColor: "#87BCDE" }}
      />

      <ParallaxLayer
        offset={0}
        speed={0}
        factor={3}
        // @ts-ignore
        style={{ backgroundImage: url("stars", true), backgroundSize: "cover" }}
      />

      <ParallaxLayer
        offset={1.3}
        speed={-0.3}
        // @ts-ignore
        style={{ pointerEvents: "none" }}>
        <img
          src={url("satellite4")}
          style={{ width: "15%", marginLeft: "70%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={1}
        speed={0.8}
        // @ts-ignore
        style={{ opacity: 0.1 }}>
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "55%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "10%", marginLeft: "15%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={1.75}
        speed={0.5}
        // @ts-ignore
        style={{ opacity: 0.1 }}>
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "70%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "40%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={1}
        speed={0.2}
        // @ts-ignore

        style={{ opacity: 0.2 }}>
        <img
          src={url("cloud")}
          style={{ display: "block", width: "10%", marginLeft: "10%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "75%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={1.6}
        speed={-0.1}
        // @ts-ignore

        style={{ opacity: 0.4 }}>
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "60%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "25%", marginLeft: "30%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "10%", marginLeft: "80%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={2.6}
        speed={0.4}
        // @ts-ignore

        style={{ opacity: 0.6 }}>
        <img
          src={url("cloud")}
          style={{ display: "block", width: "20%", marginLeft: "5%" }}
        />
        <img
          src={url("cloud")}
          style={{ display: "block", width: "15%", marginLeft: "75%" }}
        />
      </ParallaxLayer>

      <ParallaxLayer
        offset={2.5}
        speed={-0.4}
        // @ts-ignore
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}>
        <img src={url("earth")} style={{ width: "60%" }} />
      </ParallaxLayer>

      <ParallaxLayer
        offset={2}
        speed={-0.3}
        // @ts-ignore
        style={{
          backgroundSize: "80%",
          backgroundPosition: "center",
          backgroundImage: url("clients", true),
        }}
      />

      <ParallaxLayer
        offset={0}
        speed={0.1}
        // @ts-ignore
        onClick={() => React.parallax.scrollTo(1)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <img src={geslubLogo} style={{ width: "18%" }} />
          <Typography
            variant="h2"
            color="primary"
            align="center"
            style={{ fontWeight: "bold" }}>
            Geslub Dashboard
          </Typography>
        </span>
      </ParallaxLayer>

      <ParallaxLayer
        offset={1}
        speed={0.1}
        // @ts-ignore
        onClick={() => React.parallax.scrollTo(2)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <img src={url("bash")} style={{ width: "40%" }} />
      </ParallaxLayer>

      <ParallaxLayer
        offset={2}
        speed={-0}
        // @ts-ignore
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        // @ts-ignore
        onClick={() => React.parallax.scrollTo(0)}>
        <img src={url("clients-main")} style={{ width: "40%" }} />
      </ParallaxLayer>
    </Parallax>
  );
};

export default Home;
